import { render, staticRenderFns } from "./SectionFinalBD.vue?vue&type=template&id=6f6d5286&"
import script from "./SectionFinalBD.vue?vue&type=script&lang=js&"
export * from "./SectionFinalBD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports